export default "__VITE_ASSET__BY$aeR7i__"